import { render, staticRenderFns } from "./CardProductUsage.vue?vue&type=template&id=60e52451&scoped=true&"
import script from "./CardProductUsage.vue?vue&type=script&lang=js&"
export * from "./CardProductUsage.vue?vue&type=script&lang=js&"
import style0 from "./CardProductUsage.vue?vue&type=style&index=0&id=60e52451&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e52451",
  null
  
)

export default component.exports